import { NgModule } from '@angular/core';
import { TableConstructorModule } from 'src/app/components/tables/table-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from '../views.module';
import { TableUsersListComponent } from './table-users-list.component';

@NgModule({
  imports: [SharedModule, TableConstructorModule, ViewsModule],
  declarations: [TableUsersListComponent],
  exports: [TableUsersListComponent],
})
export class TableUsersListModule {}
